import i18next from 'i18next';

const rootPath = '/admin/inventories/storage-areas';

export const DETAILS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.SUB_FEATURES.INFORMATIONS'),
  path: `${rootPath}/:id/details`,
  getLink: ({ storageArea: { id } }) => `${rootPath}/${id}/details`,
};
export const SUPPLIER_PRODUCTS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('GENERAL.SUPPLIER_PRODUCT_PLURAL'),
  path: `${rootPath}/:id/supplier-products`,
  getLink: ({ storageArea: { id } }) => `${rootPath}/${id}/supplier-products`,
};
export const RECIPES = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('GENERAL.RECIPE_PLURAL'),
  path: `${rootPath}/:id/recipes`,
  getLink: ({ storageArea: { id } }) => `${rootPath}/${id}/recipes`,
};

export const STORAGE_AREA_CREATION = {
  isFullScreen: true,
  path: `${rootPath}/create`,
  isVisible: () => false,
};
